import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import ProposalTemplates from '../../../components/ProposalCreator/ProposalTemplates';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		proposalCreator: {
			fromTemplate: {
				masterProposalsIds,
				customTemplatesIds,
				loadingStatus,
			},
			isDisplayed,
		},
		driveList: { driveItems },
	} = state;

	return {
		...ownProps,
		masterProposalsIds,
		customTemplatesIds,
		loadingStatus,
		isDisplayed,
		driveItems,
	};
};

export default connect(mapStateToProps)(ProposalTemplates);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ProposalCreator/ProposalTemplates/index.tsx